// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3p4GJ","tab":"Tabs_tab__3JvKD","tabActive":"Tabs_tabActive__KHrmp"};